import { SsrService } from '@/common/services/ssr/ssr.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'fe-modal-cookies-consent',
    templateUrl: './modal-cookies-consent.component.html',
    styleUrls: ['./modal-cookies-consent.component.scss'],
})
export class ModalCookiesConsentComponent implements OnInit {
    @Output() showModal = new EventEmitter<void>();
    checkOption = true;
    constructor(public ssr: SsrService) {}

    ngOnInit(): void {
        this.initializeCookies();
    }
    private initializeCookies(): void {
        if (this.ssr.isPlatformServer()) {
            return;
        }
        const cookieConsent = localStorage.getItem(
            'cookieConsentFunctionality',
        );

        if (cookieConsent === null) {
            this.setCookieConsent(true);
        } else {
            this.checkOption = cookieConsent === 'true';
        }
    }

    public closeModal(): void {
        this.setCookieConsent(this.checkOption);
        this.showModal.emit();
    }

    private setCookieConsent(consent: boolean): void {
        localStorage.setItem('cookieConsentFunctionality', consent.toString());
    }
}
